<template>
  <ol class="breadcrumb">
    <li
      v-for="item in items"
      class="breadcrumb-item"
      :class="{ active: item.active }"
    >
      <span v-if="item.active">{{ item.text }}</span>
      <a :href="item.href" @click.prevent="pushRoute(item.href)" v-else>{{
        item.text
      }}</a>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'TsBreadcrumb',
  props: {
    items: Array
  },
  methods: {
    pushRoute(path) {
      this.$router.push(path)
    }
  }
}
</script>
